import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { Map, List, fromJS } from 'immutable';

import { Message, Icon, Button } from 'semantic-ui-react';
import Tooltip from 'material-ui/Tooltip';
import { ModalTemplate, Loading, Button as Btn, ModalEditPassword, ModalLeaveService } from 'components';

import { CtUserEdit } from 'containers';

import * as currentStatusActions from 'modules/currentStatus';

import classNames from 'classnames/bind';
import styles from './UserEditArea.css';
const cx = classNames.bind(styles);

class UserEditArea extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      editInvalid: false,
      editOnProgress: true,
      editSaveNow: false,
      editResetNow: false,
      disableSave: false
    };
  }

  setDisableSave = value => {
    const stateObj = {};
    if (this.state.disableSave !== value) {
      stateObj.disableSave = value;
    }
    if (!value && this.state.editSaveNow) {
      stateObj.editSaveNow = false;
    }
    this.setState(stateObj);
  };

  setEditInvalid = value => {
    if (this.state.editInvalid !== value) {
      const stateObj = {
        editInvalid: value
      };
      this.setState(stateObj);
    }
  };

  setEditOnProgress = value => {
    if (!value || this.state.editOnProgress !== value) {
      this.setState({ editOnProgress: value });
    }
  };

  dispatchReset = () => {
    this.setState({
      editResetNow: true
    });
  };

  dispatchInitReset = () => {
    this.setState({
      editResetNow: false
    });
  };

  dispatchSave = () => {
    this.setState({
      editSaveNow: true
    });
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { disableSave, editResetNow, editInvalid, editOnProgress, editSaveNow } = this.state;
    const { userInfo } = this.props;
    const { setDisableSave, setEditInvalid, setEditOnProgress, dispatchSave, dispatchInitReset, dispatchReset } = this;
    // 비밀번호 변경 모달
    const { isModal, isClicked, editPasswordData, leaveServiceData } = this.props;

    const renderData = (
      <div className={cx('user-edit-area')}>
        <div className={cx('user-edit-pure-title')}>
          {/* <div className={cx('title-text')}>
            {defineMessages(formatMessage({ id: 'UserEditArea_1', defaultMessage: '내 정보 수정' }))}
          </div> */}
          {isModal === 'leaveService' && (
            <ModalLeaveService isClicked={isClicked} userNo={userInfo.userNo} leaveServiceData={leaveServiceData} />
          )}
          <Button
            // color="red"
            className={cx('bt-style-gleam bt-leave')}
            onClick={() => {
              leaveServiceData.onToggleModal('leaveService');
            }}>
            {defineMessages(formatMessage({ id: 'UserEditArea_2', defaultMessage: '탈퇴하기' }))}
          </Button>
        </div>
        <CtUserEdit
          userInfo={userInfo}
          editSaveNow={editSaveNow}
          editResetNow={editResetNow}
          setEditInvalid={setEditInvalid}
          setEditOnProgress={setEditOnProgress}
          setDisableSave={setDisableSave}
          dispatchReset={dispatchReset}
          dispatchInitReset={dispatchInitReset}
        />
        <div className={cx('user-edit-bt-area')}>
          <div className={cx('bt-save-area')}>
            <Button className={cx('bt-style-gleam', 'common-button-border')} onClick={dispatchReset}>
              {defineMessages(formatMessage({ id: 'UserEditArea_4', defaultMessage: '취 소' }))}
            </Button>
            <Button
              className={cx('bt-style-gleam common-button-brand')}
              // color="green"
              loading={editOnProgress}
              disabled={disableSave && (editInvalid || editOnProgress)}
              onClick={dispatchSave}>
              {defineMessages(formatMessage({ id: 'UserEditArea_3', defaultMessage: '저 장' }))}
            </Button>
          </div>
          <div className={cx('bt-passwd-area')}>
            {isModal === 'editPassword' && (
              <ModalEditPassword isClicked={isClicked} editPasswordData={editPasswordData} />
            )}
            <Button
              // color="blue"
              className={cx('bt-style-gleam common-button-gray', 'mr-0')}
              onClick={() => {
                editPasswordData.onToggleModal('editPassword');
              }}>
              {defineMessages(formatMessage({ id: 'UserEditArea_5', defaultMessage: '비밀번호 변경' }))}
            </Button>
          </div>
        </div>
      </div>
    );

    return renderData;
  }
}

UserEditArea.propTypes = {
  //
};
UserEditArea.defaultProps = {
  //
};

export default injectIntl(UserEditArea);



// WEBPACK FOOTER //
// ./src/script/components/user/UserEditArea.js